import React, { useMemo } from 'react'

import { Button, Dropdown, Menu, Select } from 'antd'
import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'
import { faGear } from '@fortawesome/pro-solid-svg-icons'
import { TIME_PERIODS } from '../../../utils/timePeriods'
import { QuotasSettings } from '../../../Components/antd/Tables/DragTable/OverlaySettings'
import OverlaySettingsDropdown from '../../institution/Quotas/SchoolQuotasView/OverlaySettingsDropdown'
import IconButton from '../../../Components/antd/Buttons/IconButton'

const Option = Select.Option

const mapDispatchToProps = state => ({ t: getTranslate(state.locale) })

const QuotasTableSettings = ({
  overlayPrefix, visible, overlayMenuVisible, period, overlaySettings = new QuotasSettings(), isYearly,
  onClick, onPeriodChange, onVisibleChange, onOverlayMenuVisibleChange, onOverlaySettingsSelection, onIsYealyChange, onResetGravity, t
}) => {
  const periods = useMemo(() => TIME_PERIODS.map((option, index) => (
    <Option key={index} value={option.quantity}>
      {t(option.text)}
    </Option>
  )), [t])

  return (
    <Dropdown
      trigger={['click']}
      visible={visible}
      onVisibleChange={onVisibleChange}
      onClick={onClick}
      overlay={(
        <Menu>
          <Menu.ItemGroup title={t('common.period')}>
            <Menu.Item>
              <Select
                className='w-100 j-ctn-s mt-4'
                value={period.quantity}
                onChange={onPeriodChange}
              >
                {periods}
              </Select>
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.ItemGroup title={t('common.overlay')}>
            <Menu.Item>
              <OverlaySettingsDropdown
                className='w-100 j-ctn-s mt-4'
                prefix={overlayPrefix}
                visible={overlayMenuVisible}
                onVisibleChange={onOverlayMenuVisibleChange}
                onClick={onOverlayMenuVisibleChange}
                settings={overlaySettings}
                onSelection={onOverlaySettingsSelection}
              />
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.ItemGroup title={t('common.reset_gravity')}>
            <Menu.Item onClick={onResetGravity}>
              <Button> {t('common.reset')} </Button>
            </Menu.Item>
          </Menu.ItemGroup>
        </Menu>
      )}
    >
      <IconButton
        icon={faGear}
        type={isYearly ? 'primary' : 'default'}
        text={t('school_quota_view.dropdowns.configure_table')}
      />
    </Dropdown>
  )
}

export default connect(mapDispatchToProps)(QuotasTableSettings)
